// extracted by mini-css-extract-plugin
export var box = "styles_box__cxcO8";
export var boxHeader = "styles_boxHeader__tkwwo";
export var boxInfo = "styles_boxInfo__bioaa";
export var description = "styles_description__55nAW";
export var note = "styles_note__UFDj1";